import * as React from 'react';
import { MessageBar, MessageBarType, Text } from '@fluentui/react';
import type { AgentTaskPullRequestRepairProgress } from './types';

/** Shows the same server-assessed repair cycle in both PR panels, separate from PR health. */
export function PullRequestRepairProgress(props: {
    progress?: AgentTaskPullRequestRepairProgress | null;
}) {
    const { progress } = props;
    if (!progress) return null;

    if (progress.automaticAttemptsExhausted) {
        return (
            <MessageBar messageBarType={MessageBarType.warning}>
                Automatic repair limit reached ({progress.attemptNumber} of {progress.maximumAttempts}).
                {' Select Resolve to start a new cycle.'}
            </MessageBar>
        );
    }

    const attempt = progress.attemptNumber === null
        ? 'attempt unavailable'
        : `attempt ${progress.attemptNumber} of ${progress.maximumAttempts}`;
    const executionOutcome = progress.jobStatus === 3
        ? 'succeeded'
        : progress.jobStatus === 4 ? 'failed' : 'status unavailable';
    const state = [0, 1, 7].includes(progress.jobStatus)
        ? 'queued'
        : [2, 5, 6].includes(progress.jobStatus)
            ? 'in progress'
            : `execution ${executionOutcome}`;

    return (
        <Text block>
            <b>Automatic repair:</b> {attempt} {state}
            {progress.checksPending && [3, 4].includes(progress.jobStatus) ? '; checks pending' : ''}.
        </Text>
    );
}
